import React from "react";
import { history } from '../routers/AppRouter';
import { Redirect } from 'react-router-dom'
import { getAssistanceAgreementData, setAssistanceAgreementData } from '../api/api';
// SET_ASSISTANCE_AGREEMENT
export const setAssistanceAgreement = (assistanceAgreementData) => ({
    type: 'SET_ASSISTANCE_AGREEMENT',
    data: assistanceAgreementData
});

// GET_ASSISTANCE_AGREEMENT
export const getAssistanceAgreement = (assistanceAgreementData) => ({
    type: 'GET_ASSISTANCE_AGREEMENT',
    data: assistanceAgreementData
});

export const starSetAssistanceAgreement = (serverData = {}, idPartner = '') => {
    return () => {
        return  setAssistanceAgreementData(serverData, idPartner)
    }
};

export const starGetAssistanceAgreement = (idBenef = '', idPartner = '') => {
    return () => {
        return getAssistanceAgreementData(idBenef, idPartner);
    }
};





// WEBPACK FOOTER //
// ./src/actions/assistanceAgreement.js